module.exports = "<mat-list\r\n  igoClickout\r\n  [ngClass]=\"{'selectable': selection}\"\r\n  (clickout)=\"disableNavigation()\"\r\n  (click)=\"enableNavigation()\">\r\n  <ng-content></ng-content>\r\n</mat-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/shared/list/list.component.html
// module id = 855
// module chunks = 0